<template v-if='listItems.length > 0'>
  <div class="list-group section">
    <span href="#" class="list-group-item list-group-item-success">
      <div class="d-flex w-100 justify-content-between">
        <h5 class="mb-0">{{ categoryTitle }}</h5>
      </div>
    </span>

    <a
      v-for="(item, index) in listItems"
      :key="index"
      class="list-group-item list-group-item-action"
    >
      <div class="d-flex w-100 justify-content-between">
        <h6 class="mb-1">{{ item.name }}</h6>
        <div v-if="item.spicy == 1">
          <i class="fas fa-pepper-hot"></i>
        </div>
        <div v-else-if="item.spicy == 2">
          <i class="fas fa-pepper-hot"></i>
          <i class="fas fa-pepper-hot"></i>
        </div>
      </div>
      <p class="mb-1">{{ item.description2 }}</p>
      <ul class="mb-1" v-if="item.contains">
        <li v-for="(i, index) in item.contains" :key="index">{{ i }}</li>
      </ul>
      <small class="text-muted">{{ `£${item.price.toFixed(2)}` }}</small>
      <img
        class="float-right"
        v-if="item.new"
        src="../assets/new_tag.svg"
        alt="Highland Star - New tag"
        height="50"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: "MenuSection",
  props: ["listItems"],
  computed: {
    categoryTitle() {
      const activePill = this.$store.state.PillBarFilter.activePill;
      if (activePill == "p-all") {
        return this.listItems[0].type;
      }
      return "Here ya go!";
    },
  },
};
</script>

<style scoped>
.section {
  max-width: 100%;
  padding: 5px;
  /* This prevents the component from breaking between columns for different browsers*/
  -webkit-column-break-inside: avoid;
  page-break-inside: avoid;
  break-inside: avoid;
}

.fa-pepper-hot {
  color: crimson;
}
</style>